(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antelope-mead-memory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('antelope-memory-finder-v2')) {
  customElements.define('antelope-memory-finder-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.screen = 'start';
      this.history = [];
      this.answers = { taste: '', character: '' };
      this.design = !!(window.Shopify && window.Shopify.designMode);
      this.sendAnalytics = this.dataset.analytics === 'on';
      this.forward = new Set(['memory_results_view', 'memory_recommendation_click', 'memory_story_click', 'memory_quiz_click', 'memory_contact_click', 'memory_catalog_click']);

      this.addEventListener('click', (event) => {
        const el = event.target.closest('button, a');
        if (!el || !this.contains(el)) return;
        if (el.matches('a[data-event]')) {
          this.track(el.dataset.event, { product_id: el.dataset.productId, past_product_id: el.dataset.pastProductId });
          return;
        }
        if (el.dataset.result) {
          this.track(el.dataset.event || 'memory_past_product_click', { past_product_id: el.dataset.result, from_screen: this.screen });
          this.result(el.dataset.result, 'choice');
          return;
        }
        if (el.dataset.question) {
          const q = el.dataset.question, v = el.dataset.answer;
          this.answers[q] = v;
          if (q === 'taste') this.answers.character = '';
          this.querySelectorAll('[data-question]').forEach((b) => b.setAttribute('aria-pressed', String(this.answers[b.dataset.question] === b.dataset.answer)));
          this.track('memory_answer', { question_id: q, value: v });
          if (q === 'taste') {
            if (v === 'sour') this.result('supper', 'taste');
            else if (v === 'sweet' || v === 'fruity') this.go('character');
            else { this.track('memory_results_view', { past_product_id: 'none', source: 'taste' }); this.go('help'); }
          } else if (q === 'character') {
            this.result(v === 'honey' ? 'this-is-it' : 'churchill', 'taste');
          }
          return;
        }
        const action = el.dataset.action;
        if (action === 'taste') { this.track('memory_branch_select', { branch: 'taste' }); this.go('taste'); }
        else if (action === 'back') { this.track('memory_back'); this.show(this.history.pop() || 'start'); }
        else if (action === 'restart') { this.restart(true); }
      }, { signal });

      const onUrlChange = () => this.fromHash(false);
      window.addEventListener('popstate', onUrlChange, { signal });
      window.addEventListener('hashchange', onUrlChange, { signal });
      window.addEventListener('pagehide', () => {
        if (['taste', 'character'].includes(this.screen)) this.track('memory_abandon', { answers: JSON.stringify(this.answers) });
      }, { signal });
      this.addEventListener('shopify:block:select', (event) => {
        const block = event.target.closest('[data-result]');
        if (block) { this.history = []; this.show('result-' + block.dataset.result); }
      }, { signal });

      this.track('memory_page_view');
      if (!this.fromHash(true)) this.show('start', false);
    }

    disconnectedCallback() { this.controller?.abort(); this.controller = null; }

    track(event, extra = {}) {
      const detail = { event, section_id: this.dataset.sectionId, screen: this.screen, design_mode: this.design, ...extra };
      this.dispatchEvent(new CustomEvent('antelope:memory', { bubbles: true, detail }));
      if (this.design || !this.sendAnalytics || !this.forward.has(event)) return;
      const params = {};
      Object.entries(extra).forEach(([k, v]) => { if (v !== undefined && v !== null && typeof v !== 'object') params[k] = String(v); });
      try { if (typeof window.gtag === 'function') window.gtag('event', event, params); } catch (e) {}
      try { window.Shopify?.analytics?.publish?.(event, params); } catch (e) {}
    }

    keyFromHash() {
      try { return decodeURIComponent(window.location.hash.replace(/^#/, '')); } catch (e) { return ''; }
    }

    hasResult(id) {
      return !!id && /^[a-z0-9-]+$/.test(id) && !!this.querySelector('[data-panel="result-' + id + '"]');
    }

    fromHash(initial) {
      const id = this.keyFromHash();
      if (this.hasResult(id)) {
        if (this.screen !== 'result-' + id) {
          this.history = [];
          this.track('memory_results_view', { past_product_id: id, source: initial ? 'url' : 'history' });
          this.show('result-' + id, true);
        }
        return true;
      }
      if (!initial && this.screen !== 'start') this.restart(false);
      return false;
    }

    setHash(id) {
      if (this.design) return;
      const base = window.location.pathname + window.location.search;
      const next = base + (id ? '#' + id : '');
      if (next !== base + window.location.hash) {
        try { window.history.pushState(null, '', next); } catch (e) {}
      }
    }

    result(id, source) {
      if (!this.hasResult(id)) { this.go('help'); return; }
      this.track('memory_results_view', { past_product_id: id, source });
      this.go('result-' + id);
      this.setHash(id);
    }

    restart(updateUrl) {
      this.track('memory_restart');
      this.answers = { taste: '', character: '' };
      this.history = [];
      this.querySelectorAll('[aria-pressed]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      this.show('start');
      if (updateUrl) this.setHash('');
    }

    go(next) { this.history.push(this.screen); this.show(next); }

    show(next, focus = true) {
      this.screen = next;
      this.dataset.screen = next;
      this.querySelectorAll('[data-panel]').forEach((p) => { p.hidden = p.dataset.panel !== next; });
      this.querySelector('[data-back-control]').hidden = next === 'start' || next.startsWith('result-');
      this.querySelector('[data-restart-control]').hidden = next === 'start';
      this.track('memory_screen_view');
      if (focus) {
        this.querySelector('[data-panel="' + next + '"] [data-heading]')?.focus({ preventScroll: true });
        this.querySelector('[data-flow]').scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
